const carouselItems = [
  {
    title: '2026夏季韩漫阅读节',
    desc: '百部精选韩漫免费漫画限时集中推荐，涵盖恋爱、奇幻、动作、悬疑四大热门品类，下拉式阅读陪你度过清凉一夏。',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20reading%20festival%20Korean%20manhwa%20themed%20banner%20illustration%20with%20colorful%20comic%20elements%20and%20tropical%20summer%20decorations%2C%20warm%20coral%20and%20cream%20gradient%20background%2C%20festive%20atmosphere%2C%20wide%20banner%20composition%2C%20flat%20illustration%20style&width=1200&height=600&seq=carousel-01-2026&orientation=landscape',
    alt: '2026夏季韩漫阅读节',
  },
  {
    title: '奇幻韩漫专题：异世界冒险指南',
    desc: '从重生到穿越，从魔法学院到龙骑士传说，为你梳理最值得追更的奇幻韩漫免费漫画清单。',
    img: 'https://readdy.ai/api/search-image?query=A%20fantasy%20world%20Korean%20manhwa%20banner%20illustration%20with%20magical%20castles%20and%20floating%20continents%2C%20warm%20coral%20and%20amber%20gradient%2C%20epic%20fantasy%20atmosphere%2C%20wide%20banner%20composition%2C%20flat%20illustration%20style&width=1200&height=600&seq=carousel-02-2026&orientation=landscape',
    alt: '奇幻韩漫专题',
  },
  {
    title: '韩漫新番速递：本周必追连载',
    desc: '每周精选最新上架的韩漫免费漫画连载，第一时间掌握追更动态，不错过任何一部热门新作。',
    img: 'https://readdy.ai/api/search-image?query=A%20new%20release%20Korean%20manhwa%20banner%20illustration%20with%20fresh%20comic%20covers%20arrayed%20on%20display%2C%20warm%20coral%20and%20cream%20gradient%2C%20exciting%20new%20arrival%20atmosphere%2C%20wide%20banner%20composition%2C%20flat%20illustration%20style&width=1200&height=600&seq=carousel-03-2026&orientation=landscape',
    alt: '韩漫新番速递',
  },
  {
    title: '恋爱韩漫特辑：心动瞬间合集',
    desc: '从办公室恋情到校园初恋，聚合最受欢迎的恋爱题材韩漫免费漫画，每一部都让人心跳加速。',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20banner%20with%20hearts%20and%20couple%20silhouettes%20in%20soft%20coral%20and%20cream%20gradient%2C%20sweet%20romantic%20atmosphere%2C%20wide%20banner%20composition%2C%20flat%20illustration%20style&width=1200&height=600&seq=carousel-04-2026&orientation=landscape',
    alt: '恋爱韩漫特辑',
  },
  {
    title: '完结韩漫全集：一口气读到结局',
    desc: '精选已完结的高分韩漫免费漫画，无需漫长追更等待，全集下拉式畅读，一次看过瘾。',
    img: 'https://readdy.ai/api/search-image?query=A%20completed%20series%20Korean%20manhwa%20banner%20with%20stacked%20books%20and%20checkmark%20symbols%2C%20warm%20coral%20and%20cream%20gradient%2C%20satisfying%20collection%20atmosphere%2C%20wide%20banner%20composition%2C%20flat%20illustration%20style&width=1200&height=600&seq=carousel-05-2026&orientation=landscape',
    alt: '完结韩漫全集',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          专题聚焦
        </h2>
        <div className="grid grid-cols-1 gap-4 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group relative w-full rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer bg-background-50"
            >
              <div className="flex flex-col lg:flex-row">
                <div className="relative w-full lg:w-[420px] shrink-0 aspect-[2/1] lg:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-primary-500 whitespace-nowrap">
                    探索专题 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}